import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
    name: "notifications",
    initialState: {
        notifications: [],
        unreadCount: 0,
    },
    reducers: {
        addNotification: (state, action) => {
            state.notifications = action.payload.notifications;
            state.unreadCount = action?.payload?.unseenCount;
        },
    },
});

export const { addNotification, markAllAsRead } = notificationSlice.actions;

export default notificationSlice.reducer;
